import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {Label3} from "@irati/ui/src/Labels"
import {greys} from "@irati/ui/src/global/colors"
import ProfilePic from "@irati/ui/src/ProfilePicture"

const PROFILE_PIC_SIZE = 50

const Container = styled.div`
  position: relative;
  cursor: default;
  ${({size}) => `
    height: ${size}px
  `};
`

const Rank = styled(Label3)`
  color: ${greys.medium};
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  position: absolute;
  bottom: 0;
  left: -5px;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  font-size: 11px;
`

class Leader extends Component {
  static propTypes = {
    user: PropTypes.object,
    rank: PropTypes.number,
    className: PropTypes.string
  }

  static defaultProps = {
    user: null,
    rank: 1,
    className: null,
    size: PROFILE_PIC_SIZE
  }

  render() {
    const {user, rank, className} = this.props

    return (
      <Container className={className}>
        <ProfilePic user={user} regular />
        {rank && <Rank>{rank}</Rank>}
      </Container>
    )
  }
}

export default Leader
